<template>
    <div class="box-helper-wrapper">
        <div class="box-helper-button" @click="showHelper()">
            <div class="button">
                <i class="fas fa-question fa-fw" />
            </div>
        </div>
        <div class="box-helper" v-if="show" @click="hideHelper()">
            <div class="content">
                <div class="close">
                    <i class="fas fa-times fa-fw" />
                </div>
                <div class="html" v-html="content" />
            </div>
        </div>
    </div>
</template>

<style lang="scss">
@import "../../styles/vars.scss";

    .box-helper-wrapper {
        position: absolute;
        right: $padding--main * 1.5;
        top: calc((#{$padding--main} * 1.5) + 80px);
    }

    .box-helper-button {

        .button {
            width: 60px;
            height: 60px;
            // background: $color--dark;
            display: inline-block;
            border-radius: $borderradius--main;
            // color: $color--white;
            color: $color--dark;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: $fontsize--large;
            cursor: pointer;
            // opacity: .5;
            transition: $transition--main;

            &:hover {
                opacity: 1;
            }
        }
    }

    .box-helper {
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;

        .content {
            padding: $padding--main;
            background: $color--white;
            width: 800px;
            max-width: 90%;
            max-height: 80vh;
            overflow-y: auto;
            border-radius: $borderradius--main;
            box-shadow: $boxshadow--main;
            position: relative;

            .close {
                position: fixed;
                top: 30px;
                right: 30px;
                height: 30px;
                width: 30px;
                // border-radius: 30px;
                color: #fff;
                font-weight: bold;
                text-align: center;
                cursor: pointer;
                font-size: $fontsize--xl;
            }

            h1 {
                // margin-bottom: $margin--main;
            }

            h3 {
                margin-top: $margin--main;
                margin-bottom: $margin--small;
                border-bottom: 1px solid $color--dark;
                padding-bottom: 5px;
            }

            p {
                margin-bottom: $margin--small;
            }

            ul, ol {
                margin-bottom: $margin--small;

                li {
                    
                    &:not(:last-of-type) {
                        margin-bottom: $margin--small / 2;
                    }
                }
            }
        }
    }

</style>

<script>
export default {
    props: [
        'headline',
        'identifier'
    ],
    data () {
        return {
            show: false,
            content: null
        }
    },
    created () {
        if (this.identifier !== null) {
            this.getDataFromContentful()
        }
    },
    methods: {
        showHelper () {
            this.show = true
        },
        hideHelper () {
            this.show = false
        },
        getDataFromContentful () {
            const contentful = require('contentful')
            const client = contentful.createClient({
            // This is the space ID. A space is like a project folder in Contentful terms
            space: '3h0kg5qa88is',
            // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
            accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            })
            // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
            client
            .getEntries({
                content_type: 'hjaelpebokse',
                // 'fields.relation[in]': 'oekonomi.ebitda'
                'fields.relation[in]': this.identifier
            })
            // .getEntry('4SzlILGMZwweEFr9myvbxT')
            .then(entries => {
                // console.log(entries.items[0].fields.htmlIndhold.content)
                if (entries.items[0].fields.htmlIndhold.content.length > 0) {
                    this.content = '<h1>' + this.headline + '</h1>'
                    entries.items[0].fields.htmlIndhold.content.forEach((block) => {
                        // console.log(block)
                        if (block.nodeType === 'heading-3') {
                            this.content += '<h3>'
                            if (block.content.length > 0) {
                                block.content.forEach((childBlock) => {
                                    if (childBlock.marks.length > 0) {
                                        childBlock.marks.forEach((mark) => {
                                            if (mark.type === 'bold') { this.content += '<b>' }
                                            if (mark.type === 'underline') { this.content += '<u>' }
                                            this.content += childBlock.value
                                            if (mark.type === 'bold') { this.content += '</b>' }
                                            if (mark.type === 'underline') { this.content += '</u>' }
                                        })
                                    } else {
                                        this.content += childBlock.value
                                    }
                                })
                            } else {
                                this.content += block.content[0].value
                            }
                            this.content += '</h3>'
                        }
                        if (block.nodeType === 'paragraph') {
                            this.content += '<p>'
                            if (block.content.length > 0) {
                                block.content.forEach((childBlock) => {
                                    if (childBlock.marks.length > 0) {
                                        childBlock.marks.forEach((mark) => {
                                            if (mark.type === 'bold') { this.content += '<b>' }
                                            if (mark.type === 'underline') { this.content += '<u>' }
                                            this.content += childBlock.value
                                            if (mark.type === 'bold') { this.content += '</b>' }
                                            if (mark.type === 'underline') { this.content += '</u>' }
                                        })
                                    } else {
                                        this.content += childBlock.value
                                    }
                                })
                            } else {
                                this.content += block.content[0].value
                            }
                            this.content += '</p>'
                        }
                        if (block.nodeType === 'unordered-list') {
                            this.content += '<ul style="padding-left:40px;margin-bottom:15px;">'
                            block.content.forEach(listItem => {
                                this.content += '<li>'
                                if (listItem.content[0].content.length > 0) {
                                    listItem.content[0].content.forEach((childListItem) => {
                                        if (childListItem.marks.length > 0) {
                                            listItem.content[0].content[0].marks.forEach((mark) => {
                                                if (mark.type === 'bold') { this.content += '<b>' }
                                                if (mark.type === 'underline') { this.content += '<u>' }
                                                this.content += listItem.content[0].content[0].value
                                                if (mark.type === 'bold') { this.content += '</b>' }
                                                if (mark.type === 'underline') { this.content += '</u>' }
                                            })
                                        } else {
                                            this.content += childListItem.value
                                        }
                                        this.content += '<br>'
                                    })
                                } else {

                                }
                                this.content += '</li>'
                            })
                            this.content += '</ul>'
                        }
                        if (block.nodeType === 'ordered-list') {
                            this.content += '<ol style="padding-left:40px;margin-bottom:15px;">'
                            block.content.forEach(listItem => {
                                this.content += '<li>'
                                if (listItem.content[0].content.length > 0) {
                                    listItem.content[0].content.forEach((childListItem) => {
                                        if (childListItem.marks.length > 0) {
                                            listItem.content[0].content[0].marks.forEach((mark) => {
                                                if (mark.type === 'bold') { this.content += '<b>' }
                                                if (mark.type === 'underline') { this.content += '<u>' }
                                                this.content += listItem.content[0].content[0].value
                                                if (mark.type === 'bold') { this.content += '</b>' }
                                                if (mark.type === 'underline') { this.content += '</u>' }
                                            })
                                        } else {
                                            this.content += childListItem.value
                                        }
                                        this.content += '<br>'
                                    })
                                } else {

                                }
                                this.content += '</li>'
                            })
                            this.content += '</ol>'
                        }
                    })
                }
                // this.options.content = entries.items[0].fields.forklaring
                /* if (entries.items[0].fields.htmlForklaring.content.length > 0) {
                    this.options.content = ''
                    this.options.content += '<div style="margin-bottom:-15px;">'
                    entries.items[0].fields.htmlForklaring.content.forEach(content => {
                        if (content.nodeType === 'paragraph') {
                            this.options.content += '<p style="margin-bottom:15px;">' + content.content[0].value + '</p>'
                        } else if (content.nodeType === 'unordered-list') {
                            this.options.content += '<ul style="padding-left:20px;margin-bottom:15px;">'
                            content.content.forEach(listItem => {
                                this.options.content += '<li>' + listItem.content[0].content[0].value + '</li>'
                            })
                            this.options.content += '</ul>'
                        }
                    })
                    this.options.content += '</div>'
                    this.options.content = this.options.content.replace(/(?:\r\n|\r|\n)/g, '<br>')
                } */
            })
            .catch(err => console.log(err))
        }
    }
}
</script>



// WEBPACK FOOTER //
// BoxHelper.vue?4b6b4d2d